import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SAVE_NEW_ARAVOT } from '../actions/actionsTypes';
import { postDataWithHeaders } from '../httpClient';
import { SaveAravotActionType } from '../actions/saveAravotAction';
import { resetUser } from '../slices/userSlice/userSlice';

export function* saveAravot(action: SaveAravotActionType): any {
  try {
    yield call(postDataWithHeaders, '/api/v1/admin/aravots', action.headers, {
      kind: action.kind,
      price: action.price,
      active: true,
    });
    if (action.onSuccess) {
      action.onSuccess();
    }
  } catch (e: any) {
    if (e?.status === 401) {
      yield put(resetUser());
      alert('Sorry, Login Expired! Please Login again');
    } else {
      alert('Failed to save Aravos');
    }
  }
}

export function* watchSaveAravot() {
  yield takeEvery(SAVE_NEW_ARAVOT, saveAravot);
}
